import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import Footer from './Footer';

function Layout() {
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <div className="flex flex-1">
        <div className="flex-1 max-w-6xl mx-auto px-3">
          <div className="flex flex-col sm:flex-row gap-1">
            {/* Sidebar */}
            <Sidebar />
            
            <div className="flex-1 flex flex-col">
              <main className="flex-1 p-3">
                <div className="flex">
                  <div className="flex-1">
                    <Outlet />
                  </div>
                </div>
              </main>
              
              <Footer />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Layout;
